import 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';

export interface ConfirmStopTrackModalProps {
  open: boolean;

  onClose?(): void;
  onConfirm?(): void;
}

export const ConfirmStopTrackModal = ({ open, onClose, onConfirm }: ConfirmStopTrackModalProps) => (
  <Modal title="Do you want to exit?" width="medium" open={open} onClose={onClose}>
    <ModalBody tw="text-gray-15">
      This will shut down the lab environment. This means you will also lose progress that you have made so far. Be
      aware that you can't undo this
    </ModalBody>

    <ModalFooter>
      <Button variant="outline" tw="mr-2" onClick={onClose}>
        Cancel
      </Button>

      <Button onClick={onConfirm}>Yes, exit</Button>
    </ModalFooter>
  </Modal>
);
